import React from 'react';
import './search-bar.scss';
import { TouchableOpacity, View } from '../../common';
import { SVGS } from '../../assets';
import {
  dispatch,
  getSearchKey,
  updateSearchKey,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { ReactComponent as CrossIcon } from '@zonofi/svg-icons/cross-icon.svg';
import { isEmpty, isString } from 'lodash';
import clsx from 'clsx';

interface SearchBarProps {
  placeholderText: string;
  cancelButton?: JSX.Element;
  onLeftClick?: () => void;
  leftIcon?: string | JSX.Element;
  handleClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  handleFocus?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  handleClear?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  handleEnterPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  inputClassName?: string;
  onChange?: (value: string) => void;
  value?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholderText = '',
  cancelButton,
  onLeftClick,
  leftIcon = SVGS.SearchIcon,
  handleClick = () => {},
  handleFocus = () => {},
  handleClear = () => {},
  handleEnterPress = () => {},
  className = '',
  inputClassName = 'font-medium',
  onChange,
  value,
}) => {
  const searchKey = useAppSelector(getSearchKey);

  // ✅ detect controlled mode
  const isControlled = value !== undefined;
  const inputValue = isControlled ? value : searchKey;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (isControlled) {
      onChange?.(newValue);
    } else {
      dispatch(updateSearchKey(newValue));
    }
  };

  const handleClearClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (isControlled) {
      onChange?.('');
    } else {
      dispatch(updateSearchKey(''));
    }

    handleClear(e);
  };

  return (
    <div className="search-bar-with-cancel">
      <View className={clsx('search-bar', className)}>
        {isString(leftIcon) ? (
          <img src={leftIcon} alt="" onClick={onLeftClick} />
        ) : (
          <TouchableOpacity onPress={onLeftClick}>{leftIcon}</TouchableOpacity>
        )}

        <input
          type="text"
          className={clsx('search-input', inputClassName)}
          placeholder={placeholderText}
          value={inputValue}
          onChange={handleInputChange}
          inputMode="search"
          onClick={handleClick}
          onFocus={handleFocus}
          onKeyDown={handleEnterPress}
          autoFocus
        />

        {!isEmpty(inputValue) && (
          <CrossIcon
            color="#000"
            onClick={handleClearClick}
            height={16}
            width={16}
            className="cross-icon"
          />
        )}
      </View>
      {cancelButton}
    </div>
  );
};
